export default __webpack_public_path__ + "static/media/carousel4.6131182f.png";